import { render } from "./RetirementPage.vue?vue&type=template&id=08b01acb&scoped=true"
import script from "./RetirementPage.vue?vue&type=script&lang=js"
export * from "./RetirementPage.vue?vue&type=script&lang=js"

import "./RetirementPage.vue?vue&type=style&index=0&id=08b01acb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b01acb"]])

export default __exports__